import useInsightsAnalytics, { InsightsQueryParams } from 'components/insights/query/useInsightsAnalytics';
import { getNetworkPerformanceAnalyticsFilters, useNetworkPerformanceStore } from 'stores/networkPerformanceStore';

export type NetworkPerformanceQueryParams = InsightsQueryParams;

type Options = {
  queryKey?: string;
  enabled?: boolean;
};

export default function useNetworkPerformanceAnalytics(
  queryParams: NetworkPerformanceQueryParams,
  { queryKey = 'networkPerformanceAnalytics', enabled = true }: Options = {}
) {
  const filters = useNetworkPerformanceStore((state) => getNetworkPerformanceAnalyticsFilters(state));

  return useInsightsAnalytics(queryParams, filters, { queryKey, enabled });
}
